/**
 * Forbidden Page — 403
 * Shown when user is authenticated but not a Dev Admin
 */
import { Button, Result } from 'antd'
import { useTranslation } from 'react-i18next'
import { authActions } from '@store/authStore'
import { gatewayClient } from '@infrastructure/api'

export function ForbiddenPage() {
  const { t } = useTranslation()

  const handleLogout = () => {
    authActions.logout()
    gatewayClient.logout()
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#f5f5f5',
      }}
    >
      <Result
        status="403"
        title={t('errors.forbidden.title')}
        subTitle={t('errors.forbidden.subtitle')}
        extra={
          <Button type="primary" onClick={handleLogout}>
            {t('errors.forbidden.signOut')}
          </Button>
        }
      />
    </div>
  )
}

export default ForbiddenPage
